var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeroBackgroundTest2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1618,
    height: 687,
    viewBox: "0 0 1618 687",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1590 0H28C12.536 0 0 12.536 0 28V658.346C0 675.166 14.7236 688.19 31.4173 686.137L1593.42 494.066C1607.45 492.34 1618 480.417 1618 466.275V28C1618 12.536 1605.46 0 1590 0Z",
    fill: "#FFC72C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroBackgroundTest2);
export default __webpack_public_path__ + "static/media/hero_background_test_2.ac90a8590ff8530aeb1aa79f03e22fae.svg";
export { ForwardRef as ReactComponent };